module.exports = __webpack_public_path__ + "kangping/img/user-head.3dce7f2d.jpg";